interface V3IconLinkProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconLink = ({ stroke = "#ABB0BA" }: V3IconLinkProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.667 9.333a2.333 2.333 0 0 0 3.333 0l2.667-2.666a2.357 2.357 0 1 0-3.334-3.334L9 3.667" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.333 6.667a2.333 2.333 0 0 0-3.333 0L3.333 9.333a2.357 2.357 0 0 0 3.334 3.334L7 12.333M2.666 5.333V4a1.333 1.333 0 0 1 1.333-1.333h1.334M10.666 13.333h1.333A1.334 1.334 0 0 0 13.333 12v-1.333" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
